var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"text-center mt-10 mx-11",staticStyle:{"background":"--v-info-base"},attrs:{"type":"info","prominent":""}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }